import {useState} from 'react';
import {useDispatch} from 'react-redux';

import AemButton from '@/components/Aem/AemButton';
import RemoteIconV2 from '@/components/Icon/RemoteIconV2';
import PopupStickedWithSwipeCloseAnimated from '@/components/Popup/PopupStickedWithSwipeCloseAnimated/PopupStickedWithSwipeCloseAnimated';
import appContent from '@/services/content/appContent.typed';
import {hideAgeDeniedPopup} from '@/state/slices/modalSlice';

const AgeGateDeniedPopup = () => {
    const {icon, title, description, primaryButton} = appContent.getAgeGateDeniedContent()?.popup || {};
    const [isOpen, setIsOpen] = useState(true);
    const dispatch = useDispatch();

    const onAfterClose = () => {
        dispatch(hideAgeDeniedPopup());
    };

    const onRequestClose = () => {
        setIsOpen(false);
    };

    return (
        // @ts-expect-error
        <PopupStickedWithSwipeCloseAnimated
            className='flex flex-col items-center justify-center gap-2 rounded-t-xl px-6 pt-8 pb-safe-or-8 md:bottom-auto md:left-1/2 md:right-auto md:top-1/2 md:max-w-[494px] md:-translate-x-1/2 md:-translate-y-1/2 md:rounded-3xl md:pt-22'
            isCloseVisible
            isSwipeDashVisible={false}
            shouldCloseOnEsc={false}
            shouldCloseOnOverlayClick
            shouldCloseOnSwipeDown
            swipeAreaClassName='absolute inset-0'
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            onAfterClose={onAfterClose}
        >
            <RemoteIconV2 icon={icon} className='m-2' />
            <h1 className='text-light m-0 text-32 font-bold leading-125 tracking-0'>{title}</h1>
            <p className='text-light text-16 leading-15 tracking-0'>{description}</p>
            <AemButton
                className='mb-0 mt-6 md:mt-8 md:w-full'
                {...primaryButton}
                primary
                light
                onClick={onRequestClose}
            />
        </PopupStickedWithSwipeCloseAnimated>
    );
};

export default AgeGateDeniedPopup;
